var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"primary--text"},[_vm._v(" Fill out and submit your order form. ")])])
}]

export { render, staticRenderFns }